import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getSourceByMarket } from '../../../service/stocks';
import OverviewHeader from './OverviewHeader';
import OverviewTable from '../../../containers/front/overview/OverviewTable';
import LoadMore from '../../LoadMore';
import css from '../../../styles/front/overview';

class Overview extends Component {
    static propTypes = {
        // Props
        error: PropTypes.bool.isRequired,
        limit: PropTypes.number.isRequired,
        markets: PropTypes.array.isRequired,
        reloading: PropTypes.bool.isRequired,
        selectedMarket: PropTypes.object.isRequired,
        currentRank: PropTypes.string.isRequired,

        // Dispatchers
        changeMarket: PropTypes.func.isRequired,
        changeRank: PropTypes.func.isRequired,
        reloadRanks: PropTypes.func.isRequired,
        resetRanks: PropTypes.func.isRequired,
        showAll: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this._changeRank = rank => () => {
            this.props.changeRank(rank);
            this.props.reloadRanks();
        };

        this._changeMarket = market => {
            this.props.changeMarket(market);
        };
    }

    componentWillUnmount() {
        this.props.resetRanks();
    }

    renderShowAllButton() {
        const { limit, showAll } = this.props;

        if (limit === 10) return null;

        return (
            <div className={css.loadWrapper}>
                <LoadMore onClick={showAll} />
            </div>
        );
    }

    render() {
        const {
            currentRank,
            error,
            limit,
            markets,
            reloading,
            reloadRanks,
            selectedMarket,
        } = this.props;

        const ranks = [
            { label: 'winners', id: '-CHANGE_PCT' },
            { label: 'losers', id: 'CHANGE_PCT' },
            { label: 'mostTraded', id: '-TURNOVER_TOTAL' },
        ];

        // This is the height of the table with either
        // 5 or 10 items. This is needed in order for the
        // loading indicator to render correctly.
        const tableHeight = limit === 10 ? 421 : 226;

        return (
            <div className={ css.container }>
                <OverviewHeader
                    error={error}
                    markets={markets}
                    ranks={ranks}
                    selectedMarket={selectedMarket}
                    selectedRank={currentRank}
                    changeMarket={this._changeMarket}
                    changeRank={this._changeRank}
                />
                <OverviewTable
                    error={error}
                    ranking={currentRank}
                    height={tableHeight}
                    reloading={reloading}
                    reload={reloadRanks}
                    columns={[
                        'ITEM_SECTOR',
                        'LONG_NAME',
                        'LAST',
                        'LASTNZ',
                        'LASTNZ_DIV',
                        'CHANGE',
                        'CHANGE_PCT',
                        'TURNOVER',
                        'TURNOVER_MAX',
                        'TURNOVER_TOTAL',
                    ]}
                    sources={getSourceByMarket(selectedMarket)}
                />
                {this.renderShowAllButton()}
            </div>
        );
    }
}

export default Overview;



/** WEBPACK FOOTER **
 ** /src/shared/components/front/overview/Overview.js
 **/